module.exports = __webpack_public_path__ + "img/BZ.f0141514.svg";